<template>
  <va-card :title="$t('users.limits')">
    <va-button @click="exportCsv">export csv</va-button>
    <va-data-table :fields="fields" :data="users" :loading="loading" :totalPages="totalPages" @page-selected="readItems"
      api-mode>
      <template slot="avatar" slot-scope="props">
        <va-icon v-if="props.rowData.avatar === null" name="vuestic-iconset vuestic-iconset-user" :size="40"></va-icon>
        <img v-else :src="props.rowData.avatar" class="users__avatar" />
      </template>
      <template slot="actions" slot-scope="props">
        <div>
          <router-link :to="{ name: 'user-single', params: { id: props.rowData.id } }">
            <va-button>{{ $t('users.more') }}</va-button>
          </router-link>
        </div>
      </template>
      <template slot="date_joined" slot-scope="props">
        <div>
          {{ moment(props.rowData.date_joined).format('L') }}
        </div>
      </template>
    </va-data-table>
  </va-card>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
  data() {
    return {
      users: [],
      loading: false,
      limit: 50,
      page: 1,
      totalPages: 0,
    }
  },
  computed: {
    //     avatar: "http://api.rogorent.com/media/users/avatars/image_picker_155259F3-37AB-451F-A932-C8C14681C41D-2483-000002160DC458656DC_hKPlnxR.jpg"
    // birth_date: "1993-07-21"
    // city: 349697
    // country: 221
    // date_joined: "2021-12-13T19:35:43.310824Z"
    // email: "vladlenadufresne@gmail.com"
    // first_name: "Vlada"
    // get_lender_profits: 12.75
    // id: 24
    // last_name: "Kushnir"
    // location: "Camas, Washington"
    // phone: "+13606077166"
    // zip: "98607"
    fields() {
      return [{
        name: '__slot:avatar',
        width: '30px',
        dataClass: 'text-center',
      },
      {
        name: 'first_name',
        title: this.$t('users.first_name'),
      },
      {
        name: 'last_name',
        title: this.$t('users.last_name'),
      },
      {
        name: 'email',
        title: this.$t('users.email'),
      },
      {
        name: 'phone',
        title: this.$t('users.phone'),
      },
      {
        name: '__slot:date_joined',
        title: this.$t('users.date_joined'),
      },
      {
        name: 'get_lender_profits',
        title: 'LENDER PROFITS',
      },
      {
        name: 'location',
        title: this.$t('users.location'),
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
  },
  methods: {
    moment,
    async exportCsv() {
      const response = await axios.post(`${window.$ApiHost}/lenders/list/export/`)
      const blob = new Blob([response.data])
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `users-limit-${new Date()}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    },
    async readItems(page = this.page) {
      const res = await axios.get(`${window.$ApiHost}/lenders/list/`, { params: { page, limit: this.limit } })
      if (res.data) {
        this.users = res.data.results
        this.totalPages = res.data.total_pages
        this.page = page
      }
    },
  },
  async created() {
    this.readItems()
  },

}
</script>

<style lang="scss">
.users__avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.action-button {
  white-space: nowrap;
}

.serchby {
  min-width: 200px;

  @media (max-width: 700px) {
    min-width: 150px;
  }

  @media (max-width: 400px) {
    min-width: 100px;
  }

  .va-select {
    border-bottom: none;
    border-right-width: 1px;
    border-top-right-radius: 0;
  }
}

th.vuetable-th-slot-actions {
  font-size: 30px;
  text-align: right;
  color: var(--va-textColor);
}
</style>
